/* eslint-disable */
import React, { useEffect, useState, lazy, Suspense, useRef, Children } from 'react';
// import { SVBFooter } from '@svb/svb-react-components';
import { Utils } from '@svb/api-content-component';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import { ApiCoreRouterComponent } from '@svb/api-core-router-component';
import PageRender from './pages/PageRender';
import Loading from '@svb/api-loading-component/dist/components/index';
import ScrollToTop from './core/ScrollToTop';
import { browseAPIhandler } from './helpers/browseAPIhandler';
import browseMockfaqhandler from './helpers/browseMockfaqhandler';
import ErrorBoundary from './core/ErrorBoundary';
import { SVBPortalHeader } from './ui-templates/core';
import { staticDocsMenu } from './helpers/static';
import { defaultStaticFallbackSidemenu } from './helpers/static/defaultStaticSideMenu';
import { regenTokenifExpired, getCardIcons } from './helpers/utilityFunctions';
//GoogleReCaptchaProvider is wrapper to app so that to make sure you only have one instance of Google Recaptcha per page and
// it doesn't reload unecessarily when your components re-rendered
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
const SVBFooter = lazy(() =>
  import('@svb/svb-react-components/dist/components/SVBFooter/src/SVBFooter'),
);
import { useStore } from './core/useStore';
// import { sideMenu } from './helpers/sidemenu';
import './App.css';

export default function App() {
  const [loading, setloading] = useState(true);
  const initiateBrowse = useRef(false);
  // Get header and footer menu-items
  const headerContent = Utils.getFileContent('/menus/header.json');
  const footerContent = Utils.getFileContent('/menus/footer.json');
  // UseStore must be included for any api
  // const token = useStore.getState().token;
  // const setToken = (tk) => useStore.setState({ token: tk });
  // const setCatalogdata = (data) => useStore.setState({ catalogItems: data });
  // const catalogItems = useStore((state) => state.catalogItems);
  const enableRecaptcha =
    process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLE === false ||
    (typeof process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLE === 'string' &&
      process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLE.toLowerCase() === 'false')
      ? false
      : true;

  // Use helper functions to generate token and get catalog data
  const [token, setToken] = useState('');
  const { getCatalogData, regenTokenandBrowse } = browseAPIhandler();
  const { getFaqsMockData } = browseMockfaqhandler();
  const getBrowseAPis = async (localToken) => {
    return await getCatalogData(localToken)
      .then((data) => {
        useStore.setState({ apiSideMenu: data });
        useStore.setState({ defaultApiSideMenu: data });
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };
  // const getBrowseAPisFaqs = async (localToken) => {
  //   return await getFaqsItems(localToken)
  //     .then(() => setloading(false))
  //     .catch((err) => {
  //       setloading(false);
  //       console.log(err);
  //     });
  // };

  // @todo remove this block later once new AUTH refactor is ready to be published
  //This function removes new AUTH refactor pages links from both main and side menu
  //This does direct mutation on the existing array of objects
  const hideAuthRefactor = (...filterMenu) => {
    const linksToRemove = ['/apis/authorization', '/apis/json-web-signature'];
    filterMenu.forEach((manipulatedMenu) => {
      const indicesToRemove = manipulatedMenu
        .map((obj, index) => (linksToRemove.includes(obj?.link) ? index : -1))
        .filter((index) => index !== -1);
      indicesToRemove.reverse().forEach((index) => manipulatedMenu.splice(index, 1));
    });
  };

  useEffect(() => {
    // @todo remove this block later once new AUTH refactor is ready to be published
    const enableAUthRefactor = process.env.REACT_APP_AUTHREFACTOR
      ? process.env.REACT_APP_AUTHREFACTOR === true ||
        process.env.REACT_APP_AUTHREFACTOR.toLocaleLowerCase() === 'true'
      : false;
    if (enableAUthRefactor === false) {
      hideAuthRefactor(defaultStaticFallbackSidemenu, staticDocsMenu);
    }

    // Check is token exists in localStorage and use it
    // const localToken = localStorage.getItem("token");
    // if (token && token !== '') {
    //   //@this condition never matches needs to be corrected/modified
    //   regenTokenifExpired();
    //   getBrowseAPis(token);
    //   // getBrowseAPisFaqs(token);
    // } else {
    if (!initiateBrowse.current) {
      //call browse api only once
      // Regenerate token and get browse-api response
      regenTokenifExpired()
        .then((token) => {
          setToken(token);
          getBrowseAPis(token);
          // getBrowseAPisFaqs(localStorage.getItem('token'));
        })
        .catch((err) => {
          setToken(localStorage.getItem('token'));
          setloading(false);
          console.log(err);
        });
      initiateBrowse.current = true;
      // }
    }
    // @todo move this to browse API
    getFaqsMockData();
    getCardIcons();
  }, []);

  // Add constructed doc-menu links to header menu
  if (headerContent.response) {
    headerContent.response[0].subMenu = staticDocsMenu;
  }
  const baseUrl = window.location.host;
  let recaptchaID = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY || '';
  // Assign based on URL
  if (baseUrl.includes('localhost')) {
    recaptchaID = process.env.REACT_APP_GOOGLE_RECAPTCHA_LOCAL;
  }
  let routingProps = {
    id: <PageRender browse={staticDocsMenu} token={token} />,
    folderWId: <PageRender browse={staticDocsMenu} token={token} />,
    folderWFolderWId: <PageRender browse={staticDocsMenu} token={token} />,
    folderWFoldeWFolderWId: <PageRender browse={staticDocsMenu} token={token} />,
    folderWFoldeWFolderWFolderWId: <PageRender browse={staticDocsMenu} token={token} />,
    folderWFoldeWFolderWFolderWFolderWId: <PageRender browse={staticDocsMenu} token={token} />,
    homepage: <HomePage />,
  };

  const mainContent = (
    <div className='d-flex flex-column min-vh-100' id='App'>
      <Router>
        <ScrollToTop />
        {loading ? (
          <Loading />
        ) : (
          <>
            <SVBPortalHeader
              headerContent={headerContent.response}
              logo={'/svb_fcb_logo_new.svg'}
            />
            <div className='main-content flex-grow-1 position-relative'>
              <ErrorBoundary>
                <ApiCoreRouterComponent {...routingProps} />
              </ErrorBoundary>
            </div>
          </>
        )}
      </Router>
      <Suspense fallback={<></>}>
        <SVBFooter
          footerContent={footerContent.response}
          extraClasses={'mt-auto'}
          isExternal={true}
        />
      </Suspense>
    </div>
  );

  return enableRecaptcha ? (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaID}> {mainContent} </GoogleReCaptchaProvider>
  ) : (
    mainContent
  );
}
